const r=r=>(e,n)=>(e=>{var n;return new Intl.NumberFormat("en-US",{style:"currency",currency:null!==(n=null!=e?e:r)&&void 0!==n?n:"USD"})})(n).format(e);export{r as default};
//# sourceMappingURL=currency-utils.es5.js.map
